import {
   BarController,
   BarElement,
   CategoryScale,
   Chart as ChartJS,
   Filler,
   Legend,
   LineElement,
   LinearScale,
   PointElement,
   Title,
   Tooltip,
} from 'chart.js'

export default defineNuxtPlugin(() => {
   ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      BarElement,
      BarController,
      Title,
      Tooltip,
      Legend,
      Filler
   )
})
